import { Dispatch, SetStateAction } from 'react'

export interface DisplayContextProps {
  showSidebar: boolean
  setShowSidebar: Dispatch<SetStateAction<boolean>>
}

export const DisplayContextDefaultValues: DisplayContextProps = {
  showSidebar: true,
  setShowSidebar: () => {},
}
